/* eslint-disable */
export default {
  downloadSuccess: 'Loki ladattu.',
  downloadFail: 'Virhelokin lataus epäonnistui. Yritä uudelleen.',
} as const;

// @key: @#@"downloadSuccess"@#@ @source: @#@"Log downloaded."@#@
// @key: @#@"downloadFail"@#@ @source: @#@"Error log download failed. Please try again."@#@
